import { forwardRef, memo } from 'react';
import { FormattedMessage } from 'react-intl';
import Tooltip from '@rio-cloud/rio-uikit/Tooltip';

export const DataTabsSettingsTooltipMessage = () => (
    <FormattedMessage id="intl-msg:vehicle_status.datatabs.settings.tooltip" />
);

export const DataTabsSettingsTooltip = memo(
    forwardRef<HTMLDivElement>((props, ref) => (
        <Tooltip ref={ref} {...props}>
            <DataTabsSettingsTooltipMessage />
        </Tooltip>
    )),
);

DataTabsSettingsTooltip.displayName = 'DataTabsSettingsTooltip';
